import xs from "xstream"
import isolate from "@cycle/isolate"
import * as R from "ramda"

import {dumper} from '../../../utils'
import {INPUT_CHECK, MAIL_CHECK, PAGE, STATE_KEY} from '../../../constant'

import {pageViewTempl, input2Prop, createApiReq, createApiResp, createInputCheck, apiOK, apiNG, createCheckInfo} from '../../common'

import {view} from './view'
import { CheckResult } from "../../../interface"
import sampleCombine from "xstream/extra/sampleCombine"

const mailReq = createApiReq("mail");
const mailResp = createApiResp("mail");

const reCheckDomain = /(docomo.ne.jp|ezweb.ne.jp|au.com|softbank.ne.jp|i.softbank.jp)$/

const mailCheck = (input: any) => {
	const mailAddress = R.propOr("", "mailAddress", input)		
	if (!mailAddress) {
		return "メールアドレスを入力してください。"
	}
	if (!MAIL_CHECK.test(mailAddress)) {
		return '半角英数字で正確に入力してください。'
	}
	if (reCheckDomain.test(mailAddress)) {
		return 'ドコモ、au、ソフトバンクのメールアドレスはご利用いただけません。' 
	}
	return null
}

/* IMPURE TERM CHECK */
const MailForm = sources => {
  const user$ = sources.state.select([STATE_KEY.User])
	const email$ = sources.DOM.select("#email").events("input")
		.map(input2Prop("mailAddress"))
		.startWith({ mailAddress: '' })
		.remember()

	const mailReq$ = sources.DOM.select("#btnQuery").events("click")
    .compose(sampleCombine(email$, user$))
		.map(([_, { mailAddress }, { id }]: [any, any, any]) => {
      return mailReq({ mailAddress, memberId: id })
    })

  const mailError$ = email$.map(mailCheck)

	const mailResp$ = mailResp(sources.HTTP)

  const mailOk$ = mailResp$
    .filter(apiOK)
    .map(R.path(["data", "message"]))
  const mailNg$ = mailResp$
    .filter(apiNG)
    .map(R.path(["message"]))

	const msg$ = xs.merge(mailOk$,mailNg$, mailError$).startWith(null)

	const isBusy$ = xs.merge(mailReq$.mapTo(true), mailResp$.mapTo(false))

	const btnReturn$ = sources.DOM.select("#btnReturn").events("click").mapTo({type: "goBack"}); 
	const view$ = view(user$, msg$, email$, mailError$)
	const pageView = pageViewTempl(PAGE.Profile.id)
	return {
		DOM: pageView(view$),
		HTTP: mailReq$,
		loading: isBusy$,
		router: xs.merge(btnReturn$),
    // dumper: xs.merge(email$, mailCheck$),
	}
}
export default sources => isolate(MailForm)(sources)
